export const investorColors = {
    blueBtn : "#5FC8D6",
    darkBtn: '#3B3A3E',
    grayBtn: '#C0C0C0',
    green: '#28DE18'
}